import { useEffect, useMemo, useState } from "react";
import "./Item.css";
import { attachContextmenuInfo } from "../../services/contextMenuService";
import { useRef } from "react";
import { Tooltip } from "@mui/material";

const ribbonColors = ["var(--blue-300)", "var(--green-350)", "#f7931e"];

const Item = ({
  item,
  children,
  orderedProperties,
  labelMapper,
  valuePlaceholder,
  propertiesPlaceholder,
  ignoreProperties,
  ribbon,
  itemPrefix: ItemPrefix,
  itemSuffix: ItemSuffix,
  contextMenuInfo,
  computeProperties,
  hideLabels,
  lightFont,
  renderProperty,
  openRow,
  startCols,
  ...props
}) => {
  const [tooltips, setTooltips] = useState({});
  const propertyRefs = useRef({});

  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, element]) => {
      if (element) {
        newTooltips[key] = element.scrollWidth > element.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, [item, orderedProperties, computeProperties]);
  const properties = useMemo(
    () => orderedProperties ?? Object.keys(item),
    [item]
  );
  const ignoredProperties = useMemo(
    () => ignoreProperties ?? [],
    [ignoreProperties]
  );
  const computedProperties = useMemo(
    () => Object.keys(computeProperties ?? {}) ?? [],
    [computeProperties]
  );
  const computedItem = useMemo(
    () =>
      Object.entries(computeProperties ?? {}).reduce(
        (prev, [key, mapper]) => ({ ...prev, [key]: mapper(item) }),
        {}
      ),
    [computeProperties, item]
  );

  const handleOpenRow = (e) => {

    openRow(e);
  };
  return (
    <div
      {...props}
      className={`item-component ${props.onClick ? "clickable" : ""} ${props.className || ""}`}
      onContextMenu={(event) => {
        if (contextMenuInfo)
          attachContextmenuInfo({
            event,
            ...contextMenuInfo,
            options:
              typeof contextMenuInfo.options === "function"
                ? contextMenuInfo.options(item)
                : contextMenuInfo.options,
            data: item,
          });
      }}
    >
      {ribbon && (
        <div className="ribbons-container">
          {ribbon
            .filter?.((r) => r.when)
            ?.map?.((r, i, a) => (
              <span
                className="ribbon"
                key={r.label}
                style={{
                  backgroundColor:
                    r.color ?? ribbonColors[i % ribbonColors.length],
                  left:
                    i < a.length - 1
                      ? `${-0.5 * (ribbon.length - 1 - i)}rem`
                      : "",
                }}
              >
                {r.label}
              </span>
            ))}
        </div>
      )}
      <div className="left-info">
        {ItemPrefix && <ItemPrefix item={item} />}
        <div className="main-info">
          {startCols}
          {[...properties, ...computedProperties].map((label) => {
            if (ignoredProperties.includes(label)) return null;

            const value = item[label] || computedItem[label];
            const isObject =
              value && typeof value === "object" && !Array.isArray(value);

            return (
              <div key={label} className="property">
                {!hideLabels && (
                  <span className="label">{labelMapper?.[label] || label}</span>
                )}
                {isObject && item.isAircraft ? (
                  <div className="nested-object">
                    <div className="aircraft-bullet-container">
                      <div
                        className="aircraft-bullet-container-item active"
                        onClick={(e) => handleOpenRow(e)}
                      >
                        <div className="icon-flight"></div>
                        <span>
                          Active <p>{value.active}</p>
                        </span>
                      </div>
                      <div
                        className="aircraft-bullet-container-item inactive"
                        onClick={(e) => handleOpenRow(e)}
                      >
                        <div className="icon-flight"></div>
                        <span>
                          Inactive <p> {value.inactive}</p>
                        </span>
                      </div>
                      <div
                        className="aircraft-bullet-container-item hold"
                        onClick={(e) => handleOpenRow(e)}
                      >
                        <div className="icon-flight"></div>
                        <span>
                          Hold <p>{value.hold}</p>{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Tooltip
                    className="custom-tooltip"
                    ref={(el) => (propertyRefs.current[label] = el)}
                    title={tooltips[label] ? value : ""}
                    arrow
                  >
                    {renderProperty?.[label] ? (
                      renderProperty[label](item, label)
                    ) : lightFont ? (
                      <p className="light-font">
                        {value &&
                        label == "inventoryLocation" &&
                        value.includes("-") ? (
                          <>
                            {value.split("-")[0].trim()} -{" "}
                            <span>{value.split("-")[1].trim()}</span>
                          </>
                        ) : (
                          value ||
                          propertiesPlaceholder?.[label] ||
                          valuePlaceholder
                        )}
                      </p>
                    ) : (
                      <b>
                        {value ||
                          propertiesPlaceholder?.[label] ||
                          valuePlaceholder}
                      </b>
                    )}
                  </Tooltip>
                )}
              </div>
            );
          })}
          {children && children}
        </div>
      </div>
      {ItemSuffix && <ItemSuffix item={item} />}
    </div>
  );
};

export default Item;
